// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityCommentsController from "./activity_comments_controller"
application.register("activity-comments", ActivityCommentsController)

import ActivityFilesController from "./activity_files_controller"
application.register("activity-files", ActivityFilesController)

import ActivityForController from "./activity_for_controller"
application.register("activity-for", ActivityForController)

import ActivityListController from "./activity_list_controller"
application.register("activity-list", ActivityListController)

import AddFormFieldsController from "./add_form_fields_controller"
application.register("add-form-fields", AddFormFieldsController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import DepartureFormController from "./departure_form_controller"
application.register("departure-form", DepartureFormController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import EmploymentFormController from "./employment_form_controller"
application.register("employment-form", EmploymentFormController)

import EnrolmentFormController from "./enrolment_form_controller"
application.register("enrolment-form", EnrolmentFormController)

import FlashNotificationsController from "./flash_notifications_controller"
application.register("flash-notifications", FlashNotificationsController)

import FlatpickrDateController from "./flatpickr_date_controller"
application.register("flatpickr-date", FlatpickrDateController)

import FlatpickrMonthController from "./flatpickr_month_controller"
application.register("flatpickr-month", FlatpickrMonthController)

import FlatpickrTimeController from "./flatpickr_time_controller"
application.register("flatpickr-time", FlatpickrTimeController)

import FlatpickrWeekController from "./flatpickr_week_controller"
application.register("flatpickr-week", FlatpickrWeekController)

import NestedFormFieldsController from "./nested_form_fields_controller"
application.register("nested-form-fields", NestedFormFieldsController)

import OtherReasonFormController from "./other_reason_form_controller"
application.register("other-reason-form", OtherReasonFormController)

import PhoneFormController from "./phone_form_controller"
application.register("phone-form", PhoneFormController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import SelectOtherController from "./select_other_controller"
application.register("select-other", SelectOtherController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import SpecialNeedFormController from "./special_need_form_controller"
application.register("special-need-form", SpecialNeedFormController)

import ToggleHiddenController from "./toggle_hidden_controller"
application.register("toggle-hidden", ToggleHiddenController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
